export default __webpack_public_path__ + "static/media/ISSO CLASS-3_SYLLABUS_2025-26.81e278f3.pdf";